module.exports = __webpack_public_path__ + "static/media/close_circle.8359e37d.svg";